import { Level2MenuHead, Level2MenuItem } from "@/features";
import { MdDeveloperMode } from "react-icons/md";
import React, { ReactElement, useContext } from "react";
import { useTextDomainContext } from "@/app/providers";
import { permissionsDeveloper } from "@/utils";

const parentPath = "developer";

export const DeveloperMenu = (): ReactElement => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  return (
    <Level2MenuHead
      link={`/${parentPath}`}
      label={gettext("Developer")}
      codes={permissionsDeveloper}
      feature="common"
      icon={<MdDeveloperMode size={18} className="mx-3" />}
    >
      <Level2MenuItem
        link={`/${parentPath}/partners`}
        label={gettext("Partners")}
        codes={permissionsDeveloper}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/tenants`}
        label={gettext("Corporate Groups")}
        codes={permissionsDeveloper}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/users`}
        label={gettext("Users")}
        codes={permissionsDeveloper}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/orphaned-users`}
        label={gettext("Orphaned Users")}
        codes={permissionsDeveloper}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/companies`}
        label={gettext("Companies")}
        codes={permissionsDeveloper}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/roles`}
        label={gettext("Roles")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/permissions`}
        label={gettext("Permissions")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/subscriptions`}
        label={gettext("Subscription Plans")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/features`}
        label={gettext("Features")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/data-limits`}
        label={gettext("Historical Data")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/settings-keys`}
        label={gettext("Settings Keys")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/generate-email`}
        label={gettext("Generate Email")}
        codes={permissionsDeveloper}
        feature="common"
      />

      <Level2MenuItem
        link={`/${parentPath}/modals`}
        label={gettext("Modals")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/version`}
        label={gettext("Version")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/climate1`}
        label={gettext("Climate 1")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/climate2`}
        label={gettext("Carbon Emissions")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/climate3`}
        label={gettext("Carbon Footprint")}
        codes={permissionsDeveloper}
        feature="common"
      />
      <Level2MenuItem
        link={`/${parentPath}/climate4`}
        label={gettext("Consumption")}
        codes={permissionsDeveloper}
        feature="common"
      />
    </Level2MenuHead>
  );
};
